<div class="inspection-alert">
  <div class="inspection-alert__icon">
    <img src="./assets/img/campana.svg" alt="Icono de campana" />
  </div>
  <div class="inspection-alert__content">
    <h3 class="inspection-alert__title">¡Podrías necesitar una inspección!</h3>
    <p class="inspection-alert__text">
      En las próximas 24 horas te enviaremos un correo para confirmar si tu vehículo requiere inspección.
    </p>
  </div>
</div>
